import type { IPoint } from '@fluentui/react/lib/Utilities';
import type { FolderForestNodeType } from 'owa-favorites-types';
import { mutatorAction } from 'satcheljs';
import type { FolderContextMenuState } from 'owa-mail-folder-store/lib/store/schema/FolderContextMenuState';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import getMailFavoritesViewState from '../selectors/getMailFavoritesViewState';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/*
 * Sets state to spawn a context menu attached to a favorite node.
 */
export function showFavoritesContextMenu(
    nodeId: string,
    nodeType: FolderForestNodeType,
    anchor: IPoint,
    folderId?: string
): void {
    const mailboxKey = getIndexerValueForMailboxInfo(
        getSharedFavoritesStore().outlookFavorites?.get(nodeId)?.mailboxInfo ??
            getModuleContextMailboxInfo()
    );
    if (!mailboxKey) {
        return;
    }

    setContextMenuState(mailboxKey, {
        nodeId,
        nodeType,
        folderId,
        anchor,
        treeType: 'favorites',
    });
}

export const setContextMenuState = mutatorAction(
    'setContextMenuState',
    (mailboxKey: string, state: FolderContextMenuState | null) => {
        const mailFavoritesViewStat = getMailFavoritesViewState(mailboxKey);
        if (mailFavoritesViewStat) {
            mailFavoritesViewStat.contextMenuState = state;
        }
    }
);
